import { ArrowRight } from "lucide-react";
import React, { useMemo } from "react";
import { getIconPath } from "../../utils/util";
import HeaderComponent from "../Header/HeaderComponent";
// import Header from "../Header/Header";
import styles from "./style.module.css";
import BottomBar from "../../components/ui/BottomBar/BottomBar";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { useTranslation } from "react-i18next";
import HeaderTitle from "../../components/ui/HeaderTitle/HeaderTitle";
import { CONTACT } from "../../constants/contact";

const ContactUs = () => {
  const { t, i18n } = useTranslation("contactUs");
  const contacts = useMemo(() => {
    return [
      {
        iconPath: getIconPath("ico-phone"),
        label: t("telephoneNumber"),
        detail: CONTACT.PHONE,
      },
      {
        iconPath: getIconPath("ico-line-pink"),
        label: "Line",
        detail: CONTACT.LINE_ID,
      },
      {
        iconPath: getIconPath("ico-clock"),
        label: t("openTime"),
        detail: CONTACT.HOURS + " น.",
      },
      {
        iconPath: getIconPath("ico-facebook"),
        label: "Facebook",
        detail: CONTACT.FACEBOOK,
      },
    ];
  }, [t]); // ✅ add `t` here

  const isDesktop = useIsDesktop();
  return (
    <div className={styles.container}>
      <HeaderComponent title="" />
      <div className={styles.contentWrapper}>
        <HeaderTitle title={t("contactUs")} />
        <div className={styles.contactList}>
          {contacts.map((contact) => (
            <div
              className={styles.contactItem}
              key={contact.label}
              onClick={() => {
                if (contact.label === t("telephoneNumber")) {
                  window.open(CONTACT.PHONE_TEL, "_blank");
                }
                if (contact.label === "Line") {
                  window.open(CONTACT.LINE_URL, "_blank");
                }
                if (contact.label === "Facebook") {
                  window.open(CONTACT.FACEBOOK_URL, "_blank");
                }
              }}
            >
              <div className={styles.contactItemContent}>
                <img src={contact.iconPath} alt={contact.label} />
                <div>
                  <p>{contact.label}</p>
                  <p>{contact.detail}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {!isDesktop && (
          <div className={styles.bottomBar}>
            <BottomBar />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactUs;
